
.eyebrow {
	text-transform: uppercase;
	letter-spacing: 0.15em;
	font-size: 13px;
	color: var(--accent);
}

.logoutButton {
	background-color: transparent;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	opacity: 0.7;
	padding: 0;
	line-height: 1;
}

.flexCenter{
	display:flex;
	justify-content: center;
}

.signedInUserContainer{
	margin-left: auto;
	margin-bottom: 5px;
	display:flex;
	justify-content: flex-end;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

.headerTitle {
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.appBar {
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: stretch;
	padding-bottom: 10px;
	border-bottom: 1px solid var(--border);
}

.headerActions {
	display: flex;
	flex-direction: row;
	gap: 8px;
	justify-content: space-between;
	align-items: center;
}

.headerActions button {
	flex: 1;
	min-width: 0;
	padding-left: 8px;
	padding-right: 8px;
	white-space: nowrap;
	justify-content: center;
	display: inline-flex;
	align-items: center;
}

@media (max-width: 600px) {
	.headerActions { gap: 5px; }
	.headerActions button { font-size: 0.78rem; }
}

@media (min-width: 860px) {
	.appBar {
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
	}
	.headerActions {
		margin-top: 0;
	}
}
